'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPageInit$LogoutError() {
}
export { $c_Lapp_pages_AppPageInit$LogoutError as $c_Lapp_pages_AppPageInit$LogoutError };
$c_Lapp_pages_AppPageInit$LogoutError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPageInit$LogoutError.prototype.constructor = $c_Lapp_pages_AppPageInit$LogoutError;
/** @constructor */
function $h_Lapp_pages_AppPageInit$LogoutError() {
}
export { $h_Lapp_pages_AppPageInit$LogoutError as $h_Lapp_pages_AppPageInit$LogoutError };
$h_Lapp_pages_AppPageInit$LogoutError.prototype = $c_Lapp_pages_AppPageInit$LogoutError.prototype;
$c_Lapp_pages_AppPageInit$LogoutError.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.pages.-App-Page-Init$-Logout-Error.js.map
